// Analytics feature flags — toggle individual tracking modules.
// All default to true; disable per-feature if needed.

export interface AnalyticsConfig {
  readonly search: boolean;
  readonly browse: boolean;
  readonly impressions: boolean;
  readonly exitIntent: boolean;
  readonly socialProof: boolean;
  readonly customerJourney: boolean;
  readonly formAnalytics: boolean;
  readonly attribution: boolean;
  readonly deviceTracking: boolean;
  readonly connectionQuality: boolean;
  readonly phoneInteraction: boolean;
  readonly pwaTracking: boolean;
  readonly repeatVisits: boolean;
  readonly checkoutFunnel: boolean;
  readonly clickTracking: boolean;
  readonly abandonedCart: boolean;
}

const defaults: AnalyticsConfig = {
  search: true,
  browse: true,
  impressions: true,
  exitIntent: true,
  socialProof: true,
  customerJourney: true,
  formAnalytics: true,
  attribution: true,
  deviceTracking: true,
  connectionQuality: true,
  phoneInteraction: true,
  pwaTracking: true,
  repeatVisits: true,
  checkoutFunnel: true,
  clickTracking: true,
  abandonedCart: true,
};

let _config: AnalyticsConfig = { ...defaults };

export function getAnalyticsConfig(): Readonly<AnalyticsConfig> {
  return _config;
}

export function setAnalyticsConfig(overrides: Partial<AnalyticsConfig>): void {
  _config = { ..._config, ...overrides };
}
